import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

import { ParticipantFieldType } from '__generated__/graphql';

import { ParticipantField } from '../../common/ParticipantFields/ParticipantFieldInputProps';
import TimeInput from '../../common/ParticipantFields/Types/TimeInput';
import UI from '../../common/UI';

export interface ParticipantFieldFilters {
  min?: string;
  max?: string;
}

interface ParticipantFieldFiltersProps {
  field: { type: ParticipantFieldType; };
  filters?: ParticipantFieldFilters | null;
  onChange?: (update: (filters: ParticipantFieldFilters) => ParticipantFieldFilters) => void;
}

const ParticipantFieldFiltersForm = ({
  field, filters, onChange,
}: ParticipantFieldFiltersProps) => {
  if (field.type === ParticipantFieldType.time) {
    return <TimeFilters field={field} filters={filters} onChange={onChange} />;
  }

  return null;
};

const TimeFilters = ({ field, filters, onChange }: ParticipantFieldFiltersProps) => {
  const { t } = useTranslation();

  const min: ParticipantField = {
    type: field.type,
    id: 'min',
    title: t('min'),
    enabled_choices: [],
    config: null,
    has_external_validation: false,
  };

  const max: ParticipantField = {
    type: field.type,
    id: 'max',
    title: t('max'),
    enabled_choices: [],
    config: null,
    has_external_validation: false,
  };

  return (
    <FiltersContainer style={{ maxWidth: 250 }}>
      <TimeInput
        value={{ value: filters?.min }}
        onChange={((input) => onChange((filters) => ({ ...filters, min: input.value })))}
        field={min}
      />

      <TimeInput
        value={{ value: filters?.max }}
        onChange={((input) => onChange((filters) => ({ ...filters, max: input.value })))}
        field={max}
      />
    </FiltersContainer>
  );
};

const FiltersContainer = styled(UI.FormGrid)`
  ${({ theme }) => css`
    margin-top: ${theme.gutter / 4}px;
    margin-bottom: ${theme.gutter / 2}px;
    grid-gap: ${theme.gutter / 4}px;

    ${UI.InputLabel} {
      font-weight: normal;
    }
  `}
`;

export default ParticipantFieldFiltersForm;
